import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { Dropdown } from 'semantic-ui-react';
import { isJson } from './Table/utility';
import styled from 'styled-components';

export const Selection = observer(
  ({
    onChange,
    defaultValue,
    options,
    title,
    inline,
    style,
    isLoading,
    testId,
  }) => {
    const [value, setValue] = useState(defaultValue);

    const onSelectionChange = (e, data) => {
      const { value } = data;
      setValue(value);
      onChange(value, e.target.textContent);
    };

    return (
      <Container style={style}>
        {title !== '' && (
          <div data-testid={`${testId}-label`} className="ui label">
            {title}
          </div>
        )}
        <div>
          <Dropdown
            data-testid={`${testId}-wrapper`}
            noResultsMessage="No data found"
            scrolling
            closeOnBlur
            loading={isLoading}
            inline={inline}
            onChange={onSelectionChange}
            options={options}
            value={value}
            selection
            wrapSelection
          />
        </div>
      </Container>
    );
  },
);

Selection.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  title: PropTypes.string,
  inline: PropTypes.bool,
  style: PropTypes.object,
  isLoading: PropTypes.bool,
};

Selection.defaultProps = {
  title: '',
  inline: true,
  style: null,
  isLoading: false,
};

export default Selection;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
  /* background: yellow; */
  /* border: 1px solid #e8e8e8; */
  width: min-content;
  flex-wrap: nowrap;
  /* padding: 0px; */
  height: 35px;
  /* background-color: yellow; */
  margin: 0px 10px 5px 0px;
  /* height: 35px; */
  /* border-radius: 15px; */
  & > div:nth-child(1) {
    border-radius: 0.285714rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin: 0px;
    height: 38px;
    line-height: 1.7em;
    font-size: 1em;
    display: flex;
    align-self: center;
    background-color: #e8e8e8;
    white-space: nowrap;
  }
  /* & > div:nth-child(2) {
    background-color: magenta;

  } */
  & .ui.selection.dropdown {
    display: flex;
    align-items: center;
    height: max(35px, 38px);
    width: max-content;
    margin: 0px;
    padding-left: 50px;
    padding-right: 50px;
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid #e8e8e8;
    border-radius: 0.285714rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    /* min-width: 200px; */
    /* width: 100%; */
    /* border: none; */
    /* justify-content: stretch; */
  }
  & .ui.selection.dropdown > .dropdown.icon {
    padding: 0;
    padding-left: 10px;
  }
  & .ui.dropdown .menu > .item {
    font-size: 0.98em;
  }
`;

// Helper utility to get the selected option text
export const getOptionTextByValue = (options = [], value = null) => {
  if (!options.length || !value) {
    console.error(
      'Invalid arguments passed to getOptionTextByValue. Expected an array of options and a valid value for the options',
      { options, value },
    );
    return null;
  }

  const filteredOptions = options.filter((option) => {
    if (!isJson(option)) return null;
    if (!option?.hasOwnProperty('value') || !option?.hasOwnProperty('text'))
      return null;

    return option?.value === value;
  });

  if (!filteredOptions) {
    console.error(
      'Invalid options object structure. Expect an option with the shape of { value, text }. ',
    );
    return null;
  }

  if (filteredOptions.length === 0) {
    console.error(
      'Missing an expected option value returned from getOptionTextByValue.',
    );
    return null;
  }

  if (filteredOptions.length > 1) {
    console.error(
      'Invalid results. It appears there are duplicate options with the same value, which we should not have.',
    );
    return null;
  }

  return filteredOptions[0]?.text;
};
